module.exports = __webpack_public_path__ + "img/add.8d5cb21c.svg";